<template>
    <div class="container">

        <div class="example columns">
            <div class="column is-2"></div>
            <div class="column">
                <button @click="loadExample('cdk2')">Load Example Setting (CDK2)</button>
                <div>
                    <a href="/result/202110190723386338">Result</a>
                </div>
            </div>
            <div class="column">
                <button @click="loadExample('a2a')">Load Example Setting (A<sub>2A</sub>R)</button>
                <div>
                    <a href="/result/202110190723289340">Result</a>
                </div>
            </div>
            <div class="column is-2"></div>
        </div>

        <div class="block">
            <h1 class="title">Target Selection</h1>
            <TargetSelector :targets="targets" @changeTargets="onChangeTargets"></TargetSelector>
        </div>

        <div class="block">
            <h1 class="title">Types</h1>
            <div>
                <label><input type="checkbox" @change="selectAllTypes">All</label>
            </div>
            <div class="columns">
                <div class="column">
                    <label><input type="checkbox" name="EC50" v-model="types['EC50']">EC<sub>50</sub></label>
                </div>
                <div class="column">
                    <label><input type="checkbox" name="IC50" v-model="types['IC50']">IC<sub>50</sub></label>
                </div>
                <div class="column">
                    <label><input type="checkbox" name="AC50" v-model="types['AC50']">AC<sub>50</sub></label>
                </div>
                <div class="column">
                    <label><input type="checkbox" name="Kd" v-model="types['Kd']">Kd</label>
                </div>
                <div class="column">
                    <label><input type="checkbox" name="Ki" v-model="types['Ki']">Ki</label>
                </div>
                <div class="column">
                    <label><input type="checkbox" name="Potency" v-model="types['Potency']">Potency</label>
                </div>
            </div>
        </div>

        <CriteriaSelector :targets="targets" :types="types" :criteria="criteria" @changeCriteria="onChangeCriteria"></CriteriaSelector>

        <div class="block">
            <h1 class="title">Attributes</h1>
            <div>
                <label><input type="checkbox" @change="selectAllAttributes">All</label>
            </div>
            <div class="columns">
                <div class="column right">Compound:</div>
                <div class="column left"></div>
                <div class="column left">
                    <label><input type="checkbox" name="FP2" v-model="attributes['fp2']">FP2</label>
                </div>
                <div class="column left">
                    <label><input type="checkbox" name="ECFP4" v-model="attributes['ecfp4']">ECFP4</label>
                </div>
                <div class="column left">
                    <label><input type="checkbox" name="ECFP6" v-model="attributes['ecfp6']">ECFP6</label>
                </div>
                <div class="column left">
                    <label><input type="checkbox" name="MACCSKEY" v-model="attributes['maccs']">MACCS Keys</label>
                </div>
            </div>
            <div class="columns">
                <div class="column right">Target:</div>
                <div class="column left"></div>
                <div class="column left">
                    <label><input type="checkbox" name="PSSM" v-model="attributes['pssm']">PSSM</label>
                </div>
                <div class="column left"></div>
                <div class="column left"></div>
                <div class="column left"></div>
            </div>
        </div>
        <div class="block">
            <h1 class="title">Representative Negative Sample Generation</h1>
            <div class="columns">
                <div class="column is-3"></div>
                <div class="column is-4">
                    Positive Sample : Generated Negative Sample
                </div>
                <div class="column is-2">
                    <select class="input" v-model="negative_ratio" @change="updateEstimation">
                        <option value="1">1:1</option>
                        <option value="3">1:3</option>
                        <option value="5">1:5</option>
                    </select>
                </div>
                <div class="column is-3"></div>
            </div>
        </div>

        <div v-if="estimation">
            Estimated Execution Time: {{ estimation }}
        </div>

        <div class="block-no-border">
            <div>The input queries will be temporarily stored on the server, but will not be used for any other than generating calculation results. Information about queries and results will be deleted within a week.</div>
            <div>
                <button @click="generate">Generate</button>
            </div>
        </div>

    </div>

</template>

<script>
// @ is an alias to /src
import TargetSelector from '@/components/TargetSelector.vue'
import CriteriaSelector from "@/components/CriteriaSelector";

export default {
    name: 'Home',
    components: {
        TargetSelector, CriteriaSelector
    },
    data: function() {
        return {
            targets: [],
            types: {
                'EC50': false, 'IC50': false, 'AC50': false, 'Kd': false, 'Ki': false, 'Potency': false,
            },
            criteria: [5.0, 6.0],
            attributes: {
                'fp2': false, 'ecfp4': false, 'ecfp6': false, 'maccs': false,
                'pssm': false,
            },
            negative_ratio: 1,
            estimation: '',
        }
    },
    watch: {
        targets: {
            handler: function() {
                this.updateEstimation();
            },
            deep: true,
        },
        types: {
            handler: function() {
                this.updateEstimation();
            },
            deep: true,
        },
        criteria: {
            handler: function() {
                this.updateEstimation();
            },
            deep: true,
        },
        negative_ratio: {
            handler: function() {
                this.updateEstimation();
            }
        }
    },
    methods: {
        onChangeTargets(targets) {
            this.targets = targets;
        },
        onChangeCriteria(criteria) {
            console.log(criteria);
            this.criteria = criteria;
        },
        makeFormDataArray(items) {
            let list = [];
            for (let name in items) {
                if (items[name]) {
                    list.push(name);
                }
            }
            return list;
        },
        generate() {
            let formData = new FormData();
            formData.append('targets', this.targets);
            formData.append('lower', this.criteria[0]);
            formData.append('upper', this.criteria[1]);
            let types = this.makeFormDataArray(this.types);
            formData.append('types', types);
            let attributes = this.makeFormDataArray(this.attributes);
            formData.append('attributes', attributes);
            formData.append('negative_ratio', this.negative_ratio);

            const self = this;
            this.$axios.post(this.$api_base + '/api/generate', formData).then(function(response) {
                let job_id = response.data['job_id'];
                console.log(job_id);
                self.$router.push({ name: 'Result', params: {id: job_id}});
            }).catch(function(e) {
                console.log(e);
            });
        },
        selectAllTypes: function(e) {
            for (let key in this.types) {
                this.types[key] = e.target.checked;
            }
        },
        selectAllAttributes: function(e) {
            for (let key in this.attributes) {
                this.attributes[key] = e.target.checked;
            }
        },
        loadExample: function(datasetName) {
            if (datasetName == 'cdk2') {
                this.targets = ['P24941', 'P06493', 'Q00526', 'P11440'];
                this.criteria = [5.0, 8.0];
            } else if (datasetName == 'a2a') {
                this.targets = ['P29274'];
                this.criteria = [5.0, 8.0];
            }
            this.types = {
                'EC50': true, 'IC50': true, 'AC50': true, 'Kd': true, 'Ki': true, 'Potency': false,
            };
            this.attributes = {
                'fp2': true, 'ecfp4': true, 'ecfp6': true, 'maccs': true,
                'pssm': true,
            };
            this.negative_ratio = 1;
        },
        updateEstimation() {
            const types = this.types;
            let selectedTypes = Object.keys(this.types).filter(function(name) {
                return types[name]
            });
            let params = 'targets=' + this.targets.join(',')
            + '&types=' + selectedTypes.join(',')
            + '&lower=' + this.criteria[0]
            + '&upper=' + this.criteria[1]
            + '&negative_ratio=' + this.negative_ratio;

            const self = this;
            console.log(params)
            this.$axios.get(this.$api_base + '/api/estimate-execution-time?' + params).then(function(response) {
                console.log(response.data);
                let estimation = response.data['estimation'];
                if (estimation <= 0) {
                    self.estimation = 0;
                } else if (estimation < 5) {
                    self.estimation = '5 minutes';
                } else if (estimation < 10) {
                    self.estimation = '10 minutes';
                } else if (estimation < 15) {
                    self.estimation = '15 minutes';
                } else if (estimation < 30) {
                    self.estimation = '30 minutes'
                } else if (estimation < 60) {
                    self.estimation = '1 hour';
                } else {
                    self.estimation = 'several hours';
                }
            }).catch(function(e) {
                console.log(e);
            });
        }
    }
}
</script>

<style scoped>
.container {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
}

.block {
    padding: 30px;
    border: solid 1px;
    margin-top: 50px;
    margin-bottom: 50px;
}

.block-no-border {
    padding: 30px;
    margin-top: 50px;
    margin-bottom: 50px;
}

label {
  font-size: 20px;
}

.right {
    text-align: right;
}

.left {
    text-align: left;
}

button {
    width: 120px;
}

.example {
    margin-top: 50px;
}

.example button {
    width: 240px;
    height: 45px;
}
</style>
